/* PRIMAL KRISP — grouped product-siblings tabs + pack persistence
   (main-product.liquid, product_siblings + variant_picker blocks). */
(function () {
  /* ---------- Grouped tabs ---------- */
  function pkInitGroupedTabs() {
    var roots = document.querySelectorAll('[data-pk-grouped-tabs]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.__pkTabsInit) return;
      root.__pkTabsInit = true;
      var tabs = root.querySelectorAll('[data-pk-tab]');
      var panels = root.querySelectorAll('[data-pk-panel]');
      function activate(n, focusTab) {
        Array.prototype.forEach.call(tabs, function (t) {
          var on = t.getAttribute('data-pk-tab') === n;
          t.classList.toggle('pk-tab--active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          if (on && focusTab) t.focus();
        });
        Array.prototype.forEach.call(panels, function (p) {
          p.classList.toggle('pk-tab-panel--hidden', p.getAttribute('data-pk-panel') !== n);
        });
      }
      Array.prototype.forEach.call(tabs, function (t) {
        t.addEventListener('click', function () { activate(t.getAttribute('data-pk-tab'), false); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var idx = Array.prototype.indexOf.call(tabs, t);
          var next = e.key === 'ArrowRight' ? (idx + 1) % tabs.length : (idx - 1 + tabs.length) % tabs.length;
          activate(tabs[next].getAttribute('data-pk-tab'), true);
        });
      });
    });
  }

  /* ---------- Pack persistence across sibling navigation ----------
     On pack change: stamp ?pack=N onto every sibling card link.
     On page load with ?pack=N: check the matching Pack Quantity input and
     dispatch 'change' so the theme's variant logic updates price/URL/ATC. */
  function pkPackOption() {
    return document.querySelector('[data-js-product-variant][data-name*="pack"]');
  }
  function pkCurrentPack() {
    var opt = pkPackOption();
    if (!opt) return null;
    var checked = opt.querySelector('input:checked');
    return checked ? checked.value : null;
  }
  function pkStampSiblingLinks() {
    var pack = pkCurrentPack();
    if (!pack) return;
    var links = document.querySelectorAll('.product-variants--thumbnails a.product-variant__item');
    Array.prototype.forEach.call(links, function (a) {
      var href = a.getAttribute('href');
      if (!href) return;
      try {
        var u = new URL(href, window.location.origin);
        u.searchParams.set('pack', pack);
        a.setAttribute('href', u.pathname + u.search);
      } catch (e) { /* leave link untouched */ }
    });
  }
  function pkApplyPackFromUrl() {
    var wanted;
    try { wanted = new URLSearchParams(window.location.search).get('pack'); } catch (e) { return; }
    if (!wanted) return;
    var opt = pkPackOption();
    if (!opt) return;
    var inputs = opt.querySelectorAll('input');
    var target = null;
    Array.prototype.forEach.call(inputs, function (i) { if (i.value === wanted) target = i; });
    if (!target || target.checked) { pkStampSiblingLinks(); return; }
    target.checked = true;
    target.dispatchEvent(new Event('input', { bubbles: true }));
    target.dispatchEvent(new Event('change', { bubbles: true }));
    pkStampSiblingLinks();
  }

  function pkInitAll() {
    pkInitGroupedTabs();
    pkStampSiblingLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      pkInitAll();
      pkApplyPackFromUrl();
      /* retry once in case the theme's variant component initializes late */
      setTimeout(pkApplyPackFromUrl, 400);
    });
  } else {
    pkInitAll();
    pkApplyPackFromUrl();
    setTimeout(pkApplyPackFromUrl, 400);
  }

  /* keep card links stamped as the shopper changes pack */
  document.addEventListener('change', function (e) {
    var opt = e.target && e.target.closest && e.target.closest('[data-js-product-variant][data-name*="pack"]');
    if (opt) pkStampSiblingLinks();
  });

  document.addEventListener('shopify:section:load', pkInitAll);
  document.addEventListener('DOMContentLoaded', function () {
    var mo = new MutationObserver(function () { pkInitAll(); });
    mo.observe(document.body, { childList: true, subtree: true });
  });
})();
